import React, { useState } from "react";
import Navbar from "./Navbar";
import "./EventHall.css";
import { BsPinMapFill, BsPeople, BsTelephone, BsEnvelope, BsX } from "react-icons/bs";
import { MdOutlineDescription } from "react-icons/md";
import Footer from "../Footer/Footer";
import ogidiHall from "../../assets/ogidi-hall.jpg";
import ogidiHall2 from "../../assets/ogidi-hall-2.jpg";
import ajaoBanquet from "../../assets/ajao-banquet-hall.jpg";
import ajaoHall2 from "../../assets/guzape-hall.jpg";
import Area11 from "../../assets/area-11-hall.jpg";
import EnuguHall from "../../assets/enugu-hall.jpg";
import conference from "../../assets/our-conference.jpg";
import hotelplace from "../../assets/hotelplace.webp";

const halls = [
  {
    name: "Ogidi Onyemaechi Hall",
    location: "Residency Hotel Ogidi, Anambra",
    capacity: "300 guests",
    img: ogidiHall,
    desc: "Ogidi Onyemaechi Hall is suitable for conference of not more than 300 persons in attendance. Fully air conditioned and we provide you with projector, projector screen, public address system, tables and chairs. Our team can as well organize a tea break / lunch if such is needed don't hesitate to inquire further.",
  },
  {
    name: "Ogidi Onyeagom",
    location: "Residency Hotel Ogidi, Anambra",
    capacity: "150 guests",
    img: ogidiHall2,
    desc: "Ogidi Onyeagom has a capacity of 150 persons and it is fully air conditioned and we provide you with projector, projector screen, public address system, tables and chairs.",
  },
  {
    name: "Guzape Agom Hall",
    location: "Residency Hotel Guzape, Abuja",
    capacity: "150 guests",
    img: ajaoHall2,
    desc: "Fully air conditioned with 150 capacity in attendance and we provide you with projector, projector screen, public address system, tables and chairs. Our team can as well organize a tea break / lunch if such is needed don't hesitate to inquire further.",
  },
  {
    name: "Area 11 Agom Hall",
    location: "Residency Hotel Area11, Abuja",
    capacity: "150 guests",
    img: Area11,
    desc: "Area 11 Agom Hall is a 150 capacity hall, suitable for you wedding, Birthday, Conferences and we provide you with projector, projector screen, public address system, tables and chairs. Our team can as well organize a tea break / lunch if such is needed don't hesitate to inquire further.",
  },
  {
    name: "Enugu Magrata Hall",
    location: "Residency Hotel Enugu, Enugu",
    capacity: "150 guests",
    img: EnuguHall,
    desc: "Magrata Hall our halls are suitable for conference of not more than 150 persons in attendance and this a multipurpose has which can be use for you Conference, Birthday, Wedding etc.",
  },
  {
    name: "Ajao Onyemaechi hall",
    location: "Residency Hotel Ajao Estate, Lagos",
    capacity: "120 guests",
    img: ajaoBanquet,
    desc: "Ajao Onyemaechi hall is 120 persons capacity hall. The Hall is fully air conditioned and we provide you with projector, projector screen, public address system, tables and chairs",
  },
];

const events = [
  {
    title: "For Your Conferences and Board Meetings",
    img: conference,
    remote: false,
    desc: "Our halls at Residency Event Hall are the perfect choice for conferences with a capacity of up to 300 attendees. With our fully air-conditioned facilities, you can ensure a comfortable and pleasant environment for all participants. To support your conference needs, we provide essential equipment including a projector, projector screen, and a reliable public address system. These amenities will enhance your presentations and ensure clear communication throughout the event. We understand that hosting a conference involves more than just the venue and equipment. That's why our dedicated team is available to assist you in organizing a seamless experience. If you require a tea break or lunch during your conference, our team can take care of the arrangements. Simply let us know your preferences, and we'll ensure that your attendees are provided with refreshments or a satisfying meal. We encourage you to reach out to us for any further inquiries or specific requirements you may have. Our team is here to assist you in creating a successful and memorable conference at Residency Event Hall.",
  },
  {
    title: "For Your Wedding Ceremony",
    img: "https://paradiseweddings.com/blog/wp-content/uploads/2022/09/Screen-Shot-2022-09-15-at-11.14.35-AM.png",
    remote: true,
    desc: "At Residency Banquet Hall, we specialize in hosting wedding receptions, and we take pride in providing a remarkable experience for couples and their guests. Our banquet hall offers a spacious and elegant setting for your special day. Our event chairs and tables are carefully selected to ensure both style and durability. You can rest assured that our furniture stands the test of time, providing comfort and sophistication for you and your guests. To ensure a comfortable atmosphere, our banquet hall is fully air-conditioned, creating a pleasant environment regardless of the weather outside. Your guests can enjoy the festivities without any discomfort. We understand that every wedding is unique, and we offer customizable options to meet your specific preferences. Our talented team can provide quality decoration services tailored to your taste, creating a captivating ambiance that reflects the vision of your dream wedding. If you have any specific requirements or would like further clarification on our services, please do not hesitate to reach out. Our team is dedicated to making your wedding reception a memorable and enchanting occasion.",
  },
  {
    title: "For Your Birthday Celebration",
    img: "https://cdn.shopify.com/s/files/1/1459/8930/products/IMG_3707.JPG?v=1554305211",
    remote: true,
    desc: "At Residency Event Hall, we understand that a birthday party is a time for celebration, joy, and lively entertainment. That's why our hall is equipped to accommodate your need for loud music and create an unforgettable atmosphere. Our hall is thoughtfully soundproofed, ensuring that you can enjoy the music and festivities without any concerns about disturbing others. Our dedicated team is committed to providing everything you need for a successful event. Simply let us know your requirements, and we'll ensure that the necessary arrangements are made. Our goal is to make your birthday event truly memorable. We take pride in delivering exceptional service and creating an ambiance that reflects your unique style and preferences. Whether you envision an intimate gathering or a grand celebration, we are ready to turn your vision into reality. Feel free to reach out to our team for further inquiries or to discuss specific details of your birthday party. We are excited to be a part of your special occasion and look forward to making it an extraordinary experience for you and your guests.",
  },
];

const EventHall = () => {
  const [showEnquiry, setShowEnquiry] = useState(false);

  return (
    <div>
      <Navbar />

      <section className='hall-hero'>
        <img src={ogidiHall} alt='' className='hall-hero__bg' />
        <div className='hall-hero__overlay' />
        <div className='container'>
          <div className='hall-hero__content'>
            <div className='hall-hero__eyebrow'>Residency Hotels</div>
            <h1 className='hall-hero__title'>Event Halls & Banquets</h1>
            <p className='hall-hero__desc'>
              Residency Event Hall is your premier destination for hosting
              unforgettable events in an atmosphere of luxury and comfort.
            </p>
          </div>
        </div>
      </section>
      <svg
        className='hall-hero__wave'
        viewBox='0 0 1440 100'
        preserveAspectRatio='none'
      >
        <path
          d='M0,55 C240,100 480,0 720,40 C960,80 1200,10 1440,55 L1440,100 L0,100 Z'
          fill='#fff'
        />
      </svg>

      <div className='container hallPage'>
        <div className='section-head'>
          <div className='section-head__eyebrow'>Our venues</div>
          <h2>Explore Our Halls</h2>
        </div>

        <div className='row'>
          {halls.map((hall, i) => (
            <div className='col-md-4' key={i}>
              <div className='card hall-card'>
                <div className='hall-card__media'>
                  <img src={hall.img} alt={hall.name} className='card-img-top2' />
                  <span className='hall-card__badge'>
                    <BsPeople /> {hall.capacity}
                  </span>
                </div>
                <div className='card-body'>
                  <h5 className='hall-card__title'>{hall.name}</h5>
                  <p className='hall-card__location'>
                    <BsPinMapFill /> {hall.location}
                  </p>
                  <p className='hall-card__desc'>{hall.desc}</p>
                  <button
                    className='hall-card__btn'
                    onClick={() => setShowEnquiry(true)}
                  >
                    Book The Hall
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className='section-head'>
          <div className='section-head__eyebrow'>Occasions</div>
          <h2>Events You Can Host</h2>
        </div>

        {events.map((evt, i) => (
          <div className='row' key={i}>
            <div className='col-md-12'>
              <div className='card evt-card'>
                <div className='row g-0'>
                  <div className='col-md-4'>
                    <img
                      src={evt.img}
                      className='img-fluid rounded-start'
                      alt={evt.title}
                      onError={(e) => {
                        e.target.src = hotelplace;
                      }}
                    />
                  </div>
                  <div className='col-md-8'>
                    <div className='card-body'>
                      <h5 className='evt-card__title'>{evt.title}</h5>
                      <p className='evt-card__desc'>
                        <MdOutlineDescription /> {evt.desc}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {showEnquiry && (
        <div className='eh-modal' onClick={() => setShowEnquiry(false)}>
          <div className='eh-modal__card' onClick={(e) => e.stopPropagation()}>
            <button
              type='button'
              className='eh-modal__close'
              onClick={() => setShowEnquiry(false)}
              aria-label='Close'
            >
              <BsX />
            </button>
            <div className='eh-modal__head'>
              <h3>Book The Hall</h3>
              <p>
                Call any of our lines below to enquire, reserve or book a hall
                at any Residency Hotel near you.
              </p>
            </div>
            <div className='eh-modal__body'>
              <a href='tel:+2348083664874' className='eh-modal__row'>
                <span className='eh-modal__icon'>
                  <BsTelephone />
                </span>
                <span>
                  <strong>Customer Line</strong>
                  <small>08083664874</small>
                </span>
              </a>
              <a href='tel:+2348083664874' className='eh-modal__row'>
                <span className='eh-modal__icon'>
                  <BsTelephone />
                </span>
                <span>
                  <strong>Reservation</strong>
                  <small>08083664874</small>
                </span>
              </a>
              <a
                href='mailto:booking@myresidencyhotel.com'
                className='eh-modal__row'
              >
                <span className='eh-modal__icon'>
                  <BsEnvelope />
                </span>
                <span>
                  <strong>Email</strong>
                  <small>booking@myresidencyhotel.com</small>
                </span>
              </a>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default EventHall;